import React from 'react';
import PropTypes from 'prop-types';

import ExperienceCountry from 'src/app/containers/Registration/Experience/ExperienceCountry';
import ExperienceCity from 'src/app/containers/Registration/Experience/ExperienceCity';
import 'src/app/containers/Registration/Experience/ExperienceLocationComponent.scss';


class ExperienceLocationComponent extends React.PureComponent {
  render() {
    const { countryRef, cityRef } = this.props;
    return (
      <React.Fragment>
        <h4 styleName="title">Gdzie mieszkasz?</h4>

        <div styleName="location">

          <div styleName="location__country">
            <ExperienceCountry inputRef={ countryRef }/>
          </div>

          <div styleName="location__city">
            <ExperienceCity inputRef={ cityRef }/>
          </div>

        </div>
      </React.Fragment>
    );
  }
}


ExperienceLocationComponent.propTypes = {
  countryRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  cityRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};


export default ExperienceLocationComponent;
